<template>
  <div ref="print-wrapper" class="max-height">
    <div ref="print-titles-wrapper" class="print-titles-wrapper">
      <div class="print-main-title">
        <h3>{{'print' | translate}}</h3>
        <router-link :to="{ name: 'betting'}" class="n-i n-i-arrow-left-e" tag="i"></router-link>
      </div>
      <div class="print-nav-titles-wrapper">
        <div class="print-nav-titles">
          <router-link class="print-nav-title"
                       v-for="(nav, index) in navs"
                       :key="index"
                       :to="nav.route"
                       tag="div" exact>
            {{nav.name | translate}}
          </router-link>
        </div>
      </div>
    </div>
    <div class="print" :style="{height: componentHeight}">
      <router-view name="print"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import gameConfig from '../config/gameConfig';

export default {
  name: 'Print',
  data() {
    return {
      navs: [],
      componentHeight: '',
    };
  },
  computed: {
    ...mapGetters([
      'gameId',
    ]),
  },
  mounted() {
    this.componentHeight = `${this.$refs['print-wrapper'].clientHeight - this.$refs['print-titles-wrapper'].getBoundingClientRect().height.toFixed(2)}px`;
    this.navs = gameConfig[this.gameId].print.navs;
  },
};
</script>

<style lang="scss" scoped>
  .print-main-title {
    align-items: center;
    background-color: #ebebeb;
    display: flex;
    flex: 0.05;
    justify-content: space-between;
    padding: 0.975rem;
    h3 {
      text-transform: capitalize;
      font-size: 1.75rem;
    }
    i {
      font-size: 2rem;
    }
  }
  .print-nav-titles-wrapper {
    padding: 0 0.975rem;
    .print-nav-titles {
      border-bottom: 2px solid #465a65;
      display: flex;
      flex-direction: row;
      padding: 1.25rem 0 5px 0;
      .print-nav-title {
        color: rgba(69, 90, 100, 0.5);
        cursor: pointer;
        flex: 0 0 25%;
        font-weight: 400;
        max-width: 25%;
        text-transform: capitalize;
        &.router-link-exact-active {
          color: #455a64;
          font-weight: 700;
        }
      }
    }
  }
  .print {
    padding: 0.975rem;
  }
</style>
